
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/[communityPath]",
      function () {
        return require("private-next-pages/community/[communityPath]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/[communityPath]"])
      });
    }
  